import React from 'react';
import FilterInputField from '../../../components/TableFilter/ColumnsFilters/FilterInputField';
import FilterTreeSelect from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';

export function serviceProviderListColumn({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 60,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('monitoring_columnDistrict'),
      accessor: 'district',
      Cell: ({ original: { location } }) => location[`${lang}_name`] ?? '',
      maxWidth: 170,
      Filter: (
        <FilterTreeSelect
          lookupId="60"
          name="legalLocality"
          lang={lang}
          filter={item => {
            return item.ARM_gu === 'true' && item.code !== '190000000';
          }}
        />
      )
    },
    {
      Header: t('monitoring_columnLocation'),
      accessor: 'location',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ original: { district } }) => district[`${lang}_name`] ?? ''
    },
    {
      Header: t('monitoring_columnBin'),
      accessor: 'bin',
      Filter: <FilterInputField name="bin" type="number" />,
      filterable: false
    },
    {
      Header: t('monitoring_columnOrgName'),
      accessor: 'serviceProviderName',
      Cell: ({ original }) => original[`${lang}_name`],
      filterable: false
    },
    {
      Header: t('monitoring_columnTypeCode'),
      accessor: 'type_code',
      style: { textAlign: 'center' },
      Cell: ({ original }) => original[`type_code`][`${lang}_name`],
      Filter: (
        <FilterTreeSelect
          lookupId="gu_type_code"
          name="typeCode"
          lang={lang}
          filter={item => {
            return item.code === '01' || item.code === '02';
          }}
        />
      )
    },
    {
      Header: t('monitoring_columnSubTypes'),
      accessor: 'sub_types',
      Cell: ({ original }) =>
        original['sub_types'].map(el => el[`${lang}_name`]).join(', '),
      filterable: false
    },
    {
      Header: t('monitoring_columnAvailabilitySpecConditions'),
      accessor: 'group',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ original }) =>
        original['type_code']?.code === '01'
          ? original['group']
            ? t('monitoring_columnYes')
            : t('monitoring_columnNo')
          : ''
    },
    {
      Header: t('monitoring_columnAddress'),
      accessor: 'legal_address',
      Cell: ({ original }) =>
        lang === 'ru' ? original[`legal_address`] : original[`legal_address_kz`],
      filterable: false
    },
    {
      Header: t('monitoring_columnContact'),
      accessor: 'contact',
      filterable: false
    },
    {
      Header: t('monitoring_columnDesign_capacity'),
      accessor: 'design_capacity',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: t('monitoring_columnClosed'),
      accessor: 'closed',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ original }) =>
        original[`closed`] === true ? t('monitoring_columnYes') : t('monitoring_columnNo')
    },
    {
      Header: t('monitoring_columnFormOwnership'),
      accessor: 'form_ownership',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ original }) =>
        original['type_code']?.code === '01'
          ? original['form_ownership']
            ? t('monitoring_columnYes')
            : t('monitoring_columnNo')
          : ''
    },
    {
      Header: t('monitoring_columnIsGos'),
      accessor: 'legal_locality',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ original }) =>
        ['331010000', '331810000', '333420100', '334420100'].includes(
          original['legal_locality']
        )
          ? t('monitoring_columnYes')
          : t('monitoring_columnNo')
    }
  ];
}
